import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import TagsInput from '../../components/TagsInput';
const TaskCreateModal = ({ show, handleClose }) => {
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create Task</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form >
                        <Form.Group className="mb-3">
                            <Form.Label>Title:</Form.Label>
                            <Form.Control type="text" placeholder="Enter Title" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder='Enter Description' style={{resize:'none'}} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Assigned To:</Form.Label>
                            <Form.Select aria-label="Select alert type">
                                <option value="User 1">User 1</option>
                                <option value="User 2">User 2</option>
                                <option value="User 3">User 3</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Priority:</Form.Label>
                            <Form.Select aria-label="Select alert type">
                                <option value="High">High</option>
                                <option value="Medium">Medium</option>
                                <option value="Low">Low</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Due Date:</Form.Label>
                            <Form.Control type="date" placeholder="Enter alert message" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Tags</Form.Label>
                            <TagsInput />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TaskCreateModal;